import store from '../config/store'
import { get_nested_plain } from './miscellaneous'

export const checkAccess = (plain_key, defaultResponse = false) => {
  return get_nested_plain(
    plain_key,
    store.getState()?.auth?.user?.access,
    defaultResponse
  )
}
